declare global {
  interface Window {
    PARSELY?: {
      loaded?: boolean;
      onload?: () => void;
      conversions?: {
        trackLeadCapture: (label: string) => void;
        trackLinkClick: (label: string) => void;
        trackNewsletterSignup: (label: string) => void;
        trackPurchase: (label: string) => void;
        trackSubscription: (label: string) => void;
        trackCustom: (label: string) => void;
      };
    };
  }
}

export type ParselyConversionType =
  | 'trackLeadCapture'
  | 'trackLinkClick'
  | 'trackNewsletterSignup'
  | 'trackPurchase'
  | 'trackSubscription'
  | 'trackCustom';

class Parsely {
  private queue: [type: ParselyConversionType, label: string][] = [];

  constructor() {
    // Has something already set up an onload handler?
    const existingOnload = window.PARSELY?.onload;

    window.PARSELY = {
      ...window.PARSELY,
      onload: () => {
        // If so, call the existing onload handler first
        existingOnload?.();

        setTimeout(() => {
          this.flushQueue();
        }, 0);
      },
    };
  }

  private flushQueue() {
    this.queue.forEach(([type, label]) => {
      this.report(type, label);
    });

    this.queue = [];
  }

  private report(type: ParselyConversionType, label: string) {
    const conversion = window.PARSELY?.conversions?.[type];

    if (!conversion) {
      console.warn(
        `Error reporting Parsely conversion. type: ${type}, label: ${label}, error: missing conversion handler`
      );
      return;
    }

    try {
      conversion(label);
    } catch (error) {
      console.warn(
        `Error reporting Parsely conversion. type: ${type}, label: ${label}`,
        error
      );
    }
  }

  private captureEvent(type: ParselyConversionType, label: string) {
    if (window.PARSELY?.loaded) {
      this.report(type, label);
    } else {
      this.queue.push([type, label]);
    }
  }

  public trackLeadCapture(label: string) {
    this.captureEvent('trackLeadCapture', label);
  }

  public trackLinkClick(label: string) {
    this.captureEvent('trackLinkClick', label);
  }

  public trackNewsletterSignup(label: string) {
    this.captureEvent('trackNewsletterSignup', label);
  }

  public trackPurchase(label: string) {
    this.captureEvent('trackPurchase', label);
  }

  public trackSubscription(label: string) {
    this.captureEvent('trackSubscription', label);
  }

  public trackCustom(label: string) {
    this.captureEvent('trackCustom', label);
  }
}

// Singleton instance of Parsely
const parsely = new Parsely();
export default parsely;
